import { DataItem } from 'scrivito'

import { SublistItem, SublistItemContent } from '@/Atomic/Templates/Sublist'
import { DataClassName } from '@/Data/const'
import { SchemaAttributes } from '@/Data/typesV2'
import { getEnumDisplayValue } from '@/utils/CRUD/read/enum/getDisplayValue'
import { getSchemaAttributes } from '@/utils/CRUD/read/schema'
import { getSchemaName } from '@/utils/dataClassMap'
import { formatDateTime } from '@/utils/formatDateTime'

interface InvoiceSublistItemProps {
  invoice: DataItem
  flash?: boolean
  onOpen: (invoice: DataItem) => void
}

const formatAmount = (rawValue: number | undefined) => {
  if (typeof rawValue !== 'number' || !Number.isFinite(rawValue)) return ''
  return Intl.NumberFormat(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(rawValue)
}

const buildSubtitle = (
  invoice: DataItem,
  schemaAttributes?: SchemaAttributes,
) => {
  const dueAtLabel = schemaAttributes?.dueAt?.title || 'Due'
  const grossAmountLabel = schemaAttributes?.grossAmount?.title || 'Gross'
  const invoiceAtLabel = schemaAttributes?.invoiceAt?.title || 'Invoice date'

  const status = invoice.get('status') as string
  const dueAt = invoice.get('dueAt') as Date | undefined
  const invoiceAt = invoice.get('invoiceAt') as Date | undefined
  const grossAmountRaw = invoice.get('grossAmount') as number | undefined

  const statusDisplayValue =
    getEnumDisplayValue(schemaAttributes?.status?.enumValues, status) ?? status
  const grossAmount = formatAmount(grossAmountRaw)

  return [
    statusDisplayValue || '',
    dueAt ? `${dueAtLabel}: ${formatDateTime(dueAt, 'PP')}` : '',
    grossAmount ? `${grossAmountLabel}: ${grossAmount}` : '',
    invoiceAt ? `${invoiceAtLabel}: ${formatDateTime(invoiceAt, 'PP')}` : '',
  ]
    .filter(Boolean)
    .join(' · ')
}

export const InvoiceSublistItem: React.FC<InvoiceSublistItemProps> = ({
  invoice,
  flash,
  onOpen,
}) => {
  const { schemaAttributes } = getSchemaAttributes(
    getSchemaName(DataClassName.INVOICE),
  )

  const displayTitle = (invoice.get('displayTitle') as string) || ''

  return (
    <SublistItem flash={flash}>
      <SublistItemContent
        avatarIcon="invoice"
        title={displayTitle}
        subtitle={buildSubtitle(invoice, schemaAttributes)}
        onClick={() => onOpen(invoice)}
      />
    </SublistItem>
  )
}
